export default "__VITE_ASSET__DM90Gj8M__"